import React from "react";

import { Button } from "components";
import { FeeTemplateQueue } from "globalConstants";
import { TableCellProp, User } from "types";

import { ReactComponent as RemoveIcon } from "static/images/cancel.svg";
import { ReactComponent as CopyIcon } from "static/images/copy_icon.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "../feeTemplatesQueue.module.scss";

type ActiveColumnProps = {
	handleCopy: Function;
	handleEdit: Function;
	handleDelete: Function;
	isLoading: boolean;
};

const { IsDefault, TemplateId } = FeeTemplateQueue;

const ActionColumn = ({
	handleCopy,
	handleEdit,
	handleDelete,
	isLoading,
}: ActiveColumnProps) => ({
	accessor: "actions",
	disableSortBy: true,
	classNameCell: styles.feeTemplateCell,
	Cell: ({ row: { original } }: TableCellProp<User>) => {
		const isDefault = original?.[IsDefault.name];
		const templateId = original?.[TemplateId.name];

		return (
			<div className={styles.actionHolder}>
				<i className={`column-separator  ${styles.actionSeparator}`} />
				<Button
					btnIcon
					icon={<CopyIcon />}
					onClick={() => handleCopy(templateId)}
					className={styles.actionIcon}
					variant="secondary"
					size="sm"
					title="Copy"
					isLoading={isLoading}
				/>
				<Button
					btnIcon
					icon={<EditIcon />}
					onClick={() => handleEdit(templateId)}
					variant="secondary"
					size="sm"
					title="Edit"
					className={styles.actionIcon}
					isLoading={isLoading}
				/>
				<Button
					onClick={() => handleDelete(templateId)}
					size="sm"
					icon={<RemoveIcon />}
					btnIcon
					variant="secondary"
					title="Remove"
					className={styles.actionIcon}
					disabled={isDefault}
					isLoading={isLoading}
				/>
			</div>
		);
	},
});

export default ActionColumn;
